export default "__VITE_ASSET__58a06f1c__"